import { createContext } from 'react';
export const PaymentTermLoanContext: any = createContext(null);